import React from 'react';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './PaymentSuccessDialog.css';

interface PaymentSuccessDialogProps {
  open: boolean;
  consultationId?: number | null;
  onClose: () => void;
}

const PaymentSuccessDialog: React.FC<PaymentSuccessDialogProps> = ({
  open,
  consultationId,
  onClose
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    // Navigate to teleconsultation page
    navigate('/teleconsultation');
  };

  if (!open) return null;

  return (
    <div className="payment-success-overlay">
      <div className="payment-success-dialog">
        <div className="payment-success-icon">
          <CheckCircleIcon sx={{ fontSize: 64, color: '#4CAF50' }} />
        </div>
        
        <h2 className="payment-success-title">Payment Successful!</h2>
        
        <p className="payment-success-message">
          Your consultation has been booked and paid successfully.
        </p>
        
        {/* {consultationId && (
          <div className="payment-success-reference">
            <span className="reference-label">Reference ID:</span>
            <span className="reference-value">{consultationId}</span>
          </div>
        )} */}
        
        <div className="payment-success-info">
          <p>✅ You will receive a confirmation email with your video consultation link.</p>
      
          <p>Please check your email inbox for further instructions on how to join the video consultation.</p>
        </div>
        
        <button 
          className="payment-success-button"
          onClick={handleClose}
        >
          Continue to Teleconsultation
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessDialog;
